import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useUserPluginRestrictedMode } from '@app/pages/profiles/profile-details/profile-ide-provisioner/hooks/user-restricted-modes';
import { PluginRulesBundle } from '@app/pages/profiles/profile-details/profile-ide-provisioner/plugin-rules/bundles/plugin-rules-bundle';
import { PluginRulesBundleDialog } from '@modules/ide-provisioner/plugins-rules/plugin-rules-bundle-dialog/plugin-rules-bundle-dialog';
import { getApplications, getPluginRulesBundles } from '@common/store/profiles/selectors';
import { useOpenModal } from '@common/modals/hooks';
import { ProfileActions } from '@common/store/profiles/profile-reducer';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import { SettingPlaceholder } from '../common/settings-placeholder';
import { AddSettingButton } from '../common/add-setting-button';
import { SettingBlock } from '../common/setting-block';
import styles from './plugin-rules.css';
export function PluginRules(props) {
    const { profileId } = props;
    const { isRestricted } = useUserPluginRestrictedMode();
    const applications = useSelector(getApplications);
    const pluginRulesBundles = useSelector(getPluginRulesBundles);
    const dispatch = useDispatch();
    const openPluginsRulesBundleDialog = useOpenModal(PluginRulesBundleDialog, {
        profileId,
        applicationFilters: applications.rules,
        isRestrictedMode: isRestricted
    }, [profileId, applications.rules]);
    const handleOnRulesBundleClick = useCallback((pluginRulesBundle) => {
        openPluginsRulesBundleDialog({ pluginRulesBundle }).then(result => {
            if (result) {
                dispatch(ProfileActions.updatePluginRulesBundles(result.bundle));
            }
        });
    }, [dispatch, openPluginsRulesBundleDialog]);
    const handleRulesBundleRemoveClick = useCallback((bundle) => {
        dispatch(ProfileActions.deletePluginRulesBundle(bundle));
    }, [dispatch]);
    return (_jsx(SettingBlock, { header: "Plugins", headerActionComponent: _jsx(AddSettingButton, { ...assignTestId('add-rules-bundle'), onClick: () => handleOnRulesBundleClick() }), children: (pluginRulesBundles === null || pluginRulesBundles === void 0 ? void 0 : pluginRulesBundles.length) ? (pluginRulesBundles.map(bundle => (_jsx(PluginRulesBundle, { bundle: bundle, onClick: handleOnRulesBundleClick, onDelete: handleRulesBundleRemoveClick, className: styles.bundle }, bundle.id)))) : (_jsx(SettingPlaceholder, { title: "No plugin rules yet" })) }));
}
